(function (app) {

    app.provider("transactionProductApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function (transactionId, transactionProductId) {
                        return complianceHubApiGateway.get("/TransactionProducts/Transactions/" + transactionId + "/Products/" + transactionProductId);
                    };

                    service.getTransactionProducts = function(transactionId) {
                        return complianceHubApiGateway.getArray("/TransactionProducts/ForTransaction/" + transactionId);
                    };

                    service.getNonRightBridgeTransactionProducts = function (transactionId) {
                        return complianceHubApiGateway.get("/TransactionProducts/NonRightBridgeForTransaction/" + transactionId);
                    };

                    //POSTs
                    service.createTransactionProduct = function (transactionProduct) {
                        return complianceHubApiGateway.post("/TransactionProducts/", transactionProduct);
                    };
                   
                    return service;
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line